import { BILIARY_IMPRESSION, biliaryFindings } from "../groups/biliary";
import { RENAL_BLADDER_FINDINGS } from "../groups/bladder";
import { KIDNEY_FINDINGS, RENAL_IMPRESSION } from "../groups/renal";
import { option, type UsWorksheetDefinition } from "../us-fields";

export const US_BILIARY_RENAL: UsWorksheetDefinition = {
  examType: "us_biliary_renal",
  version: 1,
  indications: [
    option("ruq_pain", "RUQ pain"),
    option("abdominal_pain", "Abdominal pain"),
    option("right_flank_pain", "Right Flank pain"),
    option("vomiting", "Vomiting"),
    option("fever", "Fever"),
    option("sepsis", "Sepsis"),
  ],
  otherIndication: true,
  sections: [
    {
      id: "biliary_findings",
      label: "Biliary findings",
      role: "findings",
      technicallyLimited: true,
      fields: biliaryFindings("Other biliary findings"),
    },
    {
      id: "kidney",
      label: "kidney",
      role: "findings",
      repeatPerSide: ["right", "left"],
      technicallyLimitedBy: "bladder",
      fields: KIDNEY_FINDINGS,
    },
    {
      id: "bladder",
      label: "Bladder",
      role: "findings",
      technicallyLimited: true,
      fields: RENAL_BLADDER_FINDINGS,
    },
    {
      id: "biliary_impression",
      label: "Biliary impression",
      role: "impression",
      fields: [BILIARY_IMPRESSION],
    },
    {
      id: "renal_impression",
      label: "Renal impression",
      role: "impression",
      fields: RENAL_IMPRESSION,
    },
  ],
  normalImpressions: [
    { sectionId: "biliary_impression", value: "normal_biliary" },
  ],
  billing: {
    codes: [
      {
        cpt: "76775",
        label: "Renal/bladder ultrasound, limited",
        preTick: true,
      },
      { cpt: "76705", label: "Abdominal ultrasound, limited" },
    ],
  },
};
